/**
 * Gemeinsame Helfer fuer Namens-Avatare: Initialen + deterministische
 * Pastell-Farbe. Extrahiert aus ItemCard/ParticipantCard, damit beide
 * Komponenten dieselbe Farbe fuer denselben Namen zeigen.
 */

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? "").join("");
}

export function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) & 0xfffffff;
  }
  const hue = hash % 360;
  return `hsl(${hue}, 52%, 44%)`;
}
